<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Procurement">Procurement</a></li>
                                <li class="breadcrumb-item active">Pengaturan Procurement</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="card cardputih collapsed-card">
                                <div class="card-header border-transparent" style="cursor: pointer;"
                                    data-card-widget="collapse">
                                    <h3 class="card-title">Data Informasi Kegiatan</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12 float-left">
                                            <label>Kode Register<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="register" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedregister" @update:modelValue="onregisterChange"
                                                style="background-color: #ffffff;display: none;"></v-select>
                                            <v-select multiple :options="register" :reduce="(label) => label.code"
                                                label="label" @option:selected="onregisterChangeSelect($event)"
                                                @option:deselected="onregisterChangeDeselect($event)"
                                                v-model="arraynamaregister" id="registerku"
                                                style="background-color: #ffffff;padding-bottom: 10px;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>PIU <small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="id_user" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedid_user" @update:modelValue="onid_userChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Nama Kegiatan <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm"
                                                    id="Nama_Kegiatan" name="Nama_Kegiatan" placeholder="Nama Kegiatan"
                                                    v-model="Nama_Kegiatan" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Kode Kegiatan <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="kode"
                                                    name="kode" placeholder="Kode Kegiatan" v-model="kode" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>Lokasi<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="lokasi" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedlokasi" @update:modelValue="onlokasiChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>Komponen / Output<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="Komponen" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedKomponen" @update:modelValue="onKomponenChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>Sub Komponen<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="SubKomponen" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedSubKomponen"
                                                @update:modelValue="onSubKomponenChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>Jenis Pekerjaan <small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="jenispekerjaan" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedjenispekerjaan"
                                                @update:modelValue="onjenispekerjaanChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"
                                                disabled></v-select>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Urutan Kegiatan <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="number" class="form-control form-control-sm" id="urut"
                                                    name="urut" placeholder="Urutan Kegiatan" v-model="urut" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="card cardputih">
                                <div class="card-header border-transparent" style="cursor: pointer;"
                                    data-card-widget="collapse">
                                    <h3 class="card-title">Form Input Data Procurement</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12 float-left">
                                            <label>Metode Lelang<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="lelang" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedlelang" @update:modelValue="onlelangChange"
                                                style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                                        </div>
                                        <div class="col-sm-12 float-left"
                                            v-for="(datadata, urutdata) in tahapanpekerjaan" :key="urutdata">
                                            <div class="position-relative p-3 bg-cyan">
                                                <div class="ribbon-wrapper">
                                                    <div class="ribbon bg-primary" style="font-size: xx-small;">
                                                        Tahapan {{ urutdata + 1 }}
                                                    </div>
                                                </div>
                                                {{ datadata.nama_indo }}<br>
                                                <small class="text-warning">{{ datadata.nama }}</small>
                                                <div class="col-sm-12 float-left">&nbsp;</div>
                                                <div class="col-sm-12 float-left"
                                                    v-for="(datadatadetail, urutdatadetail) in datadata.tahapan"
                                                    :key="urutdatadetail" style="font-size: smaller;">
                                                    <div class="row">
                                                        <div class="col-sm-12 float-left">
                                                            <label class="text-success">Tahap
                                                                {{ urutdatadetail + 1 }}
                                                            </label>
                                                            <div class="custom-control custom-checkbox">
                                                                <input
                                                                    class="custom-control-input custom-control-input-success"
                                                                    type="checkbox"
                                                                    :checked="datadatadetail.pilihtahapan"
                                                                    :id="'Status_pekerjaan_' + datadata.id + datadatadetail.id" @click="rubahchek('Status_pekerjaan_' + datadata.id + datadatadetail.id,datadata.id + datadatadetail.id)">
                                                                <label
                                                                    :for="'Status_pekerjaan_' + datadata.id + datadatadetail.id"
                                                                    class="custom-control-label text-black">
                                                                    {{ datadatadetail.nama }}<br>
                                                                    <small class="text-primary">
                                                                        {{ datadatadetail.nama_eng }}
                                                                    </small>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12 float-left">&nbsp;</div>
                                                        <div class="col-sm-4 float-left">
                                                            <div class="card card-row card-default">
                                                                <div class="card-header bg-info">
                                                                    <h3 class="card-title">
                                                                        Rencana
                                                                    </h3>
                                                                </div>
                                                                <div class="card-body">
                                                                    <label class="text-black">Mulai</label>
                                                                    <div class="input-group mb-3">
                                                                        <div class="input-group-prepend">
                                                                            <span class="input-group-text"><i
                                                                                    class="fab fa-creative-commons-share"></i></span>
                                                                        </div>
                                                                        <input type="date"
                                                                            class="form-control form-control-sm"
                                                                            :id="'RencanaMulai_date_' + datadata.id + datadatadetail.id"
                                                                            :value="datadatadetail.rencanamulai" :disabled="!datadatadetail.pilihtahapan">
                                                                    </div>
                                                                    <label class="text-black">Selesai</label>
                                                                    <div class="input-group mb-3">
                                                                        <div class="input-group-prepend">
                                                                            <span class="input-group-text"><i
                                                                                    class="fab fa-creative-commons-share"></i></span>
                                                                        </div>
                                                                        <input type="date"
                                                                            class="form-control form-control-sm"
                                                                            :id="'RencanaSelesai_date_' + datadata.id + datadatadetail.id"
                                                                            :value="datadatadetail.rencanaselesai" :disabled="!datadatadetail.pilihtahapan">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4 float-left">
                                                            <div class="card card-row card-default">
                                                                <div class="card-header bg-success">
                                                                    <h3 class="card-title">
                                                                        Realisasi
                                                                    </h3>
                                                                </div>
                                                                <div class="card-body">
                                                                    <label class="text-black">Mulai</label>
                                                                    <div class="input-group mb-3">
                                                                        <div class="input-group-prepend">
                                                                            <span class="input-group-text"><i
                                                                                    class="fab fa-creative-commons-share"></i></span>
                                                                        </div>
                                                                        <input type="date"
                                                                            class="form-control form-control-sm"
                                                                            :id="'RealisasiMulai_date_' + datadata.id + datadatadetail.id"
                                                                            :value="datadatadetail.mulai" :disabled="!datadatadetail.pilihtahapan">
                                                                    </div>
                                                                    <label class="text-black">Selesai</label>
                                                                    <div class="input-group mb-3">
                                                                        <div class="input-group-prepend">
                                                                            <span class="input-group-text"><i
                                                                                    class="fab fa-creative-commons-share"></i></span>
                                                                        </div>
                                                                        <input type="date"
                                                                            class="form-control form-control-sm"
                                                                            :id="'RealisasiSelesai_date_' + datadata.id + datadatadetail.id"
                                                                            :value="datadatadetail.selesai" :disabled="!datadatadetail.pilihtahapan">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4 float-left">
                                                            <div class="card card-row card-default">
                                                                <div class="card-header bg-pink">
                                                                    <h3 class="card-title">
                                                                        File Lampiran
                                                                    </h3>
                                                                </div>
                                                                <div class="card-body">
                                                                    <!--IKON PETA 1-->
                                                                    <div class="col-sm-12">
                                                                        <div class="input-group mb-3">
                                                                            <div class="input-group-prepend">
                                                                                <span class="input-group-text"><i
                                                                                        class="far fa-file-image"></i></span>
                                                                            </div>
                                                                            <input type="file"
                                                                                class="form-control form-control-sm"
                                                                                :id="'fileToUploadfilenya_tahapan' + datadata.id + datadatadetail.id"
                                                                                :name="'fileToUploadfilenya_tahapan' + datadata.id + datadatadetail.id"
                                                                                placeholder="fileToUpload"
                                                                                style="font-size: smaller;"
                                                                                accept="application/pdf" :disabled="!datadatadetail.pilihtahapan">
                                                                            <input type="hidden"
                                                                                class="form-control form-control-sm"
                                                                                :id="'filenya_tahapan' + datadata.id + datadatadetail.id"
                                                                                :name="'filenya_tahapan' + datadata.id + datadatadetail.id"
                                                                                :value="datadatadetail.filenya_tahapan"
                                                                                placeholder="File Lampiran">
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-12">
                                                                        <label>Opsi</label>
                                                                        <div class="row">
                                                                            <div class="col-sm-6">
                                                                                <div class="progress">
                                                                                    <div class="progress-bar"
                                                                                        role="progressbar"
                                                                                        aria-valuenow="0"
                                                                                        aria-valuemin="0"
                                                                                        aria-valuemax="100"
                                                                                        style="width:0%"
                                                                                        :id="'persennyafilenya_tahapan' + datadata.id + datadatadetail.id">
                                                                                        <span
                                                                                            :id="'tulisanpersenfilenya_tahapan' + datadata.id + datadatadetail.id">0%</span>
                                                                                    </div>
                                                                                </div>
                                                                                <br>
                                                                                <span class="text-success"
                                                                                    :id="'suksesnyafilenya_tahapan' + datadata.id + datadatadetail.id"></span>
                                                                            </div>
                                                                            <div class="col-sm-4 text-center">
                                                                                <button type="button" :disabled="!datadatadetail.pilihtahapan" 
                                                                                    class="btn btn-warning btn-sm lebar text-white" :id="'tombolupload'+datadata.id + datadatadetail.id"
                                                                                    @click="uploadfile('filenya_tahapan' + datadata.id + datadatadetail.id, 'application/pdf')">Upload
                                                                                    File</button>
                                                                                <button type="button" :disabled="!datadatadetail.pilihtahapan"
                                                                                    class="btn btn-danger btn-sm lebar" :id="'tombolhapus'+datadata.id + datadatadetail.id"
                                                                                    @click="clearfilepeta('filenya_tahapan' + datadata.id + datadatadetail.id)">Hapus
                                                                                    File</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-12">
                                                                        <span
                                                                            v-if="datadatadetail.filenya_tahapan != '' && datadatadetail.filenya_tahapan != null"
                                                                            class="text-success">
                                                                            <a :href="folderdokumen + datadatadetail.filenya_tahapan"
                                                                                target="_blank">Lihat Lampiran</a>
                                                                        </span>
                                                                        <span v-else>&nbsp;</span>
                                                                    </div>
                                                                    <!--IKON PETA 1 END-->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 float-left">&nbsp;</div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 float-left">

                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="card cardputih">
                                <div class="card-header border-transparent" style="cursor: pointer;"
                                    data-card-widget="collapse">
                                    <h3 class="card-title">Opsi</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        @click="simpan()" v-if="(secretencData == 'Tambah' && leveluser != 9)"
                                        data-toggle="tooltip" data-placement="left" title="Simpan data.."><i
                                            class="fas fa-plus-square"></i>
                                        Simpan
                                    </button>
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        v-if="(secretencData != 'Tambah' && leveluser != 9)" @click="update()"
                                        data-toggle="tooltip" data-placement="left" title="Update data.."><i
                                            class="fa fa-check-circle"></i>
                                        Update
                                    </button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.." v-if="leveluser != 9">
                                        <i class="fas fa-window-close"></i> Batal
                                    </button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.." v-if="leveluser == 9">
                                        <i class="fas fa-fast-backward"></i> Kembali
                                    </button>
                                </div>
                                <div class="card-footer p-3">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">&nbsp;</div>
                        <div class="col-sm-12">&nbsp;</div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            Komponen: [],
            dataKomponen: [],
            defaultSelectedKomponen: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedKomponen: '',
            selectedKomponenlabel: '',

            SubKomponen: [],
            dataSubKomponen: [],
            defaultSelectedSubKomponen: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedSubKomponen: '',
            selectedSubKomponenlabel: '',

            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedid_user: 0,

            jenispekerjaan: [],
            datajenispekerjaan: [],
            defaultSelectedjenispekerjaan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedjenispekerjaan: 0,
            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedlokasi: '',

            register: [],
            dataregister: [],
            defaultSelectedregister: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedregister: '',

            lelang: [],
            datalelang: [],
            defaultSelectedlelang: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedlelang: '',

            urut: '',
            kode: '',
            OWP: '',
            OWP_usd: '',
            OWP_lain: '',
            validasi: false,
            paramselectedregister: [],
            arraynamaregister: [],
            AWP: [],
            DISBURSEMENT: [],
            project_id: process.env.VUE_APP_PROJECT_ID,
            folderdokumen: process.env.VUE_APP_URL_API + 'parastapainnovation_program-File?f=',
            tahapanpekerjaan: [],
        }
    },
    methods: {
        cekisi(kode) {
            alert(document.getElementById(kode).value);
        },
        rubahchek(kode,acuan) {
            //alert(document.getElementById(kode).checked);
            document.getElementById('RencanaMulai_date_'+acuan).disabled = !document.getElementById(kode).checked;
            document.getElementById('RencanaSelesai_date_'+acuan).disabled = !document.getElementById(kode).checked;
            document.getElementById('RealisasiMulai_date_'+acuan).disabled = !document.getElementById(kode).checked;
            document.getElementById('RealisasiSelesai_date_'+acuan).disabled = !document.getElementById(kode).checked;
            document.getElementById('fileToUploadfilenya_tahapan'+acuan).disabled = !document.getElementById(kode).checked;
            document.getElementById('tombolupload'+acuan).disabled = !document.getElementById(kode).checked;
            document.getElementById('tombolhapus'+acuan).disabled = !document.getElementById(kode).checked;
        },
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        onregisterChangeSelect(events) {
            this.paramselectedregister = [];
            for (let i = 0; i < events.length; i++) {
                try {
                    this.paramselectedregister.push((events[i].tag));
                } catch (error) {

                }
            }
            //alert(JSON.stringify(this.paramselectedregister));
        },
        onregisterChangeDeselect(events) {
            //alert(JSON.stringify(events));
            var temp = [];
            temp.push(events);
            //alert(JSON.stringify(temp));
            var yghilang = '';
            for (let i = 0; i < temp.length; i++) {
                try {
                    yghilang = (temp[i].tag);
                } catch (error) {

                }
            }

            var temparray = [];
            for (let i = 0; i < this.paramselectedregister.length; i++) {
                //alert(this.paramselectedregister[i])
                //alert('Hilang '+(yghilang))
                if (this.paramselectedregister[i] !== yghilang) {
                    try {
                        temparray.push(this.paramselectedregister[i]);
                    } catch (error) {

                    }
                }
            }
            this.paramselectedregister = temparray;
            //alert(JSON.stringify(this.paramselectedregister));
        },
        formattulisrupiah(kodenya) {
            var rupiah = document.getElementById(kodenya);
            rupiah.addEventListener('keyup', function (e) {
                // tambahkan 'Rp.' pada saat form di ketik
                // gunakan fungsi formatRupiah() untuk mengubah angka yang di ketik menjadi format angka
                rupiah.value = formatRupiah(this.value, '');
            });

            /* Fungsi formatRupiah */
            function formatRupiah(angka, prefix) {
                var separator = '';
                var number_string = angka.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return prefix == undefined ? rupiah : (rupiah ? rupiah : '');
            }
        },
        onKomponenChange(a) {
            try {
                this.selectedKomponen = this.Komponen[a].tag;
                this.selectedKomponenlabel = this.Komponen[a].label;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedKomponen);
            this.getsubkomponen();
        },
        onSubKomponenChange(a) {
            try {
                this.selectedSubKomponen = this.SubKomponen[a].tag;
                this.selectedSubKomponenlabel = this.SubKomponen[a].label;
            }
            catch (err) {
                return;
            }
        },
        async getsubkomponen() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedKomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataSubKomponen = [];
                        this.SubKomponen = [];
                        this.dataSubKomponen = Response.data.content.data;
                        this.dataSubKomponen.forEach((item) => {
                            this.SubKomponen.push({
                                label: item.nama,
                                code: this.dataSubKomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.defaultSelectedSubKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.SubKomponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.dataSubKomponen = [];
                        this.SubKomponen = [];
                        this.defaultSelectedSubKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.SubKomponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onjenispekerjaanChange(a) {
            try {
                this.selectedjenispekerjaan = this.jenispekerjaan[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedjenispekerjaan);
        },
        onregisterChange(a) {
            try {
                this.selectedregister = this.register[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onlelangChange(a) {
            try {
                this.selectedlelang = this.lelang[a].tag;
                this.lihattahapan();
            }
            catch (err) {
                return;
            }
        },
        lihattahapan() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            this.tahapanpekerjaan = [];
            mainAPI5.get("parastapainnovation_tahapanpekerjaan-GetAll?random=" + random + "&project_id=" + this.project_id + "&id_kegiatan=" + this.secretencData + "&jenis_pekerjaan=" + this.selectedjenispekerjaan + "&metodelelang=" + this.selectedlelang).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.tahapanpekerjaan = [];
                        this.tahapanpekerjaan = Response.data.content.data;
                        this.halamanloading = false;
                    }
                    else {
                        this.tahapanpekerjaan = [];
                        this.halamanloading = false;
                    }
                }
            ).catch(error => {
                console.log(error);
                this.tahapanpekerjaan = [];
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            mainAPI5.get("parastapainnovation_userproject-GetALLPIU?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            this.id_user.push({
                                label: item.nama,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.kodesatker,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            mainAPI5.get("parastapainnovation_jenispekerjaan-GetJenisPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datajenispekerjaan = [];
                        this.jenispekerjaan = [];
                        this.datajenispekerjaan = Response.data.content.data;
                        this.datajenispekerjaan.forEach((item) => {
                            this.jenispekerjaan.push({
                                label: item.nama,
                                code: this.datajenispekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.jenispekerjaan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            mainAPI5.get("parastapainnovation_lokasi-KotaProyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            mainAPI5.get("parastapainnovation_lelang-GetMasterLelang?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalelang = [];
                        this.lelang = [];
                        this.datalelang = Response.data.content.data;
                        this.datalelang.forEach((item) => {
                            this.lelang.push({
                                label: item.nama,
                                code: this.datalelang.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lelang.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            mainAPI5.get("parastapainnovation_koderegister-GetKodeRegister?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataregister = [];
                        this.register = [];
                        this.dataregister = Response.data.content.data;
                        this.dataregister.forEach((item) => {
                            this.register.push({
                                label: item.kode_register_lengkap,
                                code: this.dataregister.indexOf(item) + 1,
                                tag: item.kode_register,
                            });
                        });
                        this.register.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });


            const mainAPI6 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

            mainAPI6.get("parastapainnovationKomponen-GetProyekKomponen?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataKomponen = [];
                        this.Komponen = [];
                        this.dataKomponen = Response.data.content.data;
                        this.dataKomponen.forEach((item) => {
                            this.Komponen.push({
                                label: item.nama,
                                code: this.dataKomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.defaultSelectedKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.Komponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });

                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            mainAPI6.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedKomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataSubKomponen = [];
                        this.SubKomponen = [];
                        this.dataSubKomponen = Response.data.content.data;
                        this.dataSubKomponen.forEach((item) => {
                            this.SubKomponen.push({
                                label: item.nama,
                                code: this.dataSubKomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.defaultSelectedSubKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.SubKomponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });

                    }
                    else {
                        this.defaultSelectedSubKomponen = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.SubKomponen.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        ontabelChange(a) {
            try {
                this.selectedtabel = this.tabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            window.location.replace("/Procurement");
        },
        uploadfile(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", "filenya_tahapan");
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationimg-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = '';
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepeta(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", "filenya_tahapan");
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationimg-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    document.getElementById(idnya).value == '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var mainAPIDataSingelcari = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });

            var random = Math.random();
            mainAPIDataSingel.get("parastapainnovation_proc-GetByID?id=" + this.secretencData + "&random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.Nama_Kegiatan = Response.data.content.data[0].Nama_Kegiatan;

                    var id_userpmis = Response.data.content.data[0].id_user;
                    if (id_userpmis != '') {
                        this.defaultSelectedid_user = {
                            code: Response.data.content.data[0].kode_satker,
                            label: Response.data.content.data[0].nama_satker,
                            tag: Response.data.content.data[0].kode_satker,
                        };
                        this.selectedid_user = Response.data.content.data[0].kode_satker;
                    }
                    var tipe_work = Response.data.content.data[0].tipe_work;
                    if (tipe_work != '') {
                        this.defaultSelectedjenispekerjaan = {
                            code: Response.data.content.data[0].tipe_work,
                            label: Response.data.content.data[0].Kategori,
                            tag: Response.data.content.data[0].tipe_work,
                        };
                    }

                    this.defaultSelectedlokasi = {
                        code: Response.data.content.data[0].Lokasi,
                        label: Response.data.content.data[0].namalokasi,
                        tag: Response.data.content.data[0].Lokasi,
                    };

                    this.defaultSelectedlelang = {
                        code: Response.data.content.data[0].metodelelang,
                        label: Response.data.content.data[0].namalelang,
                        tag: Response.data.content.data[0].metodelelang,
                    };

                    this.selectedlokasi = Response.data.content.data[0].Lokasi;
                    this.selectedlelang = Response.data.content.data[0].metodelelang;

                    if (Response.data.content.data[0].Lokasi == '') {
                        this.defaultSelectedlokasi = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.selectedlokasi = '';
                    }

                    if (Response.data.content.data[0].metodelelang == '0') {
                        this.defaultSelectedlelang = {
                            code: 0,
                            label: 'Pilih Salah Satu',
                            tag: '',
                        };
                        this.selectedlelang = '';
                    }

                    this.selectedjenispekerjaan = Response.data.content.data[0].tipe_work;
                    var registernya = Response.data.content.data[0].register;
                    this.arraynamaregister = [];
                    try {
                        var myArray = registernya.split(",");
                    } catch (error) {
                        var myArray = [];
                    }

                    //alert(myArray.length);

                    mainAPIDataSingelcari.get("parastapainnovation_koderegister-GetKodeRegister?random=" + random + "&project_id=" + this.project_id).then(
                        Response => {
                            this.datapesan = Response.data.message;
                            //alert(this.datapesan);
                            if (this.datapesan == 'data diketemukan') {
                                this.dataregister = [];
                                this.register = [];
                                this.dataregister = Response.data.content.data;
                                this.dataregister.forEach((item) => {
                                    for (let i = 0; i < myArray.length; i++) {
                                        if (item.kode_register == myArray[i]) {
                                            //this.arraynamaregister.push(item.kode_register_lengkap);
                                            this.arraynamaregister.push({
                                                label: item.kode_register_lengkap,
                                                code: this.dataregister.indexOf(item) + 1,
                                                tag: item.kode_register,
                                            });

                                            this.paramselectedregister.push(item.kode_register);
                                        }
                                    }
                                    if (item.kode_register == registernya) {
                                        this.defaultSelectedregister = {
                                            code: this.dataregister.indexOf(item) + 1,
                                            label: item.kode_register_lengkap,
                                            tag: item.kode_register,
                                        };
                                        this.selectedregister = item.kode_register;
                                    }
                                    this.register.push({
                                        label: item.kode_register_lengkap,
                                        code: this.dataregister.indexOf(item) + 1,
                                        tag: item.kode_register,
                                    });
                                });
                            }
                            this.halamanloading = false;
                        }
                    ).catch(error => {
                        console.log(error);
                        //this.ClearlocalStorage();
                        this.halamanloading = false;
                    });


                    document.getElementById('kode').value = Response.data.content.data[0].kode;
                    document.getElementById('urut').value = Response.data.content.data[0].urut;
                    document.getElementById('Nama_Kegiatan').value = Response.data.content.data[0].Nama_Kegiatan;
                    //this.Adendum = Response.data.content.data[0].ADENDUM;
                    this.kode = Response.data.content.data[0].kode;
                    this.urut = Response.data.content.data[0].urut;
                    this.Nama_Kegiatan = Response.data.content.data[0].Nama_Kegiatan;
                    var Komponentemp = Response.data.content.data[0].Komponen;
                    var SubKomponentemp = Response.data.content.data[0].SubKomponen;
                    this.OWP = this.G_numFormat(Response.data.content.data[0].NilaiOWP);
                    this.OWP_usd = this.G_numFormat(Response.data.content.data[0].NilaiOWP_usd);
                    this.OWP_lain = this.G_numFormat(Response.data.content.data[0].NilaiOWP_lain);
                    this.AWP = Response.data.content.data[0].NilaiAWP;
                    this.DISBURSEMENT = Response.data.content.data[0].DISBURSEMENT;

                    //alert(Komponentemp);

                    setTimeout(() => {
                        for (let i = 0; i < this.Komponen.length; i++) {
                            if (Komponentemp == this.Komponen[i].label) {
                                this.defaultSelectedKomponen = {
                                    code: this.Komponen[i].code,
                                    label: this.Komponen[i].label,
                                    tag: this.Komponen[i].tag,
                                };
                                this.selectedKomponenlabel = Komponentemp;
                            }
                        }

                        for (let i = 0; i < this.SubKomponen.length; i++) {
                            if (SubKomponentemp == this.SubKomponen[i].label) {
                                this.defaultSelectedSubKomponen = {
                                    code: this.SubKomponen[i].code,
                                    label: this.SubKomponen[i].label,
                                    tag: this.SubKomponen[i].tag,
                                };
                                this.selectedSubKomponenlabel = SubKomponentemp;
                            }
                        }
                    }, 500); // 2000 milliseconds = 2 seconds

                    this.tahapanpekerjaan = Response.data.content.data[0].tahapanpekerjaan;
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })
        },
        validasidata() {
            if (this.tahapanpekerjaan == []) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Tahapan Procurement..',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }

            var kodetahapan = '';
            var idtahapan = '';
            var pilihtahapan = '';
            var rencanamulaitahapan = '';
            var rencanaselesaitahapan = '';
            var mulaitahapan = '';
            var selesaitahapan = '';
            var filenya_tahapan = '';
            for (let z = 0; z < this.tahapanpekerjaan.length; z++) {
                for (let i = 0; i < this.tahapanpekerjaan[z].tahapan.length; i++) {
                    //alert(this.tahapanpekerjaan[z].tahapan[i].id);
                    if ((i == 0) && (z == 0)) {
                        kodetahapan = kodetahapan + this.tahapanpekerjaan[z].id.toString();
                        idtahapan = idtahapan + this.tahapanpekerjaan[z].tahapan[i].id.toString();
                        pilihtahapan = pilihtahapan + document.getElementById('Status_pekerjaan_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).checked;
                        if (document.getElementById('RencanaMulai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value == '') {
                            var RencanaMulai_date_ = '0000-00-00';
                        }
                        else {
                            var RencanaMulai_date_ = document.getElementById('RencanaMulai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        }
                        rencanamulaitahapan = rencanamulaitahapan + RencanaMulai_date_;

                        if (document.getElementById('RencanaSelesai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value == '') {
                            var RencanaSelesai_date_ = '0000-00-00';
                        }
                        else {
                            var RencanaSelesai_date_ = document.getElementById('RencanaSelesai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        }
                        rencanaselesaitahapan = rencanaselesaitahapan + RencanaSelesai_date_;

                        if (document.getElementById('RealisasiMulai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value == '') {
                            var RealisasiMulai_date_ = '0000-00-00';
                        }
                        else {
                            var RealisasiMulai_date_ = document.getElementById('RealisasiMulai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        }
                        mulaitahapan = mulaitahapan + RealisasiMulai_date_;


                        if (document.getElementById('RealisasiSelesai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value == '') {
                            var RealisasiSelesai_date_ = '0000-00-00';
                        }
                        else {
                            var RealisasiSelesai_date_ = document.getElementById('RealisasiSelesai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        }
                        selesaitahapan = selesaitahapan + RealisasiSelesai_date_;
                        filenya_tahapan = filenya_tahapan + document.getElementById('filenya_tahapan' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value;
                    }
                    else {
                        kodetahapan = kodetahapan + '|' + this.tahapanpekerjaan[z].id.toString();
                        idtahapan = idtahapan + ',' + this.tahapanpekerjaan[z].tahapan[i].id.toString();
                        pilihtahapan = pilihtahapan + ',' + document.getElementById('Status_pekerjaan_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).checked;

                        if (document.getElementById('RencanaMulai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value == '') {
                            var RencanaMulai_date_ = '0000-00-00';
                        }
                        else {
                            var RencanaMulai_date_ = document.getElementById('RencanaMulai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        }
                        rencanamulaitahapan = rencanamulaitahapan + ',' + RencanaMulai_date_;

                        if (document.getElementById('RencanaSelesai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value == '') {
                            var RencanaSelesai_date_ = '0000-00-00';
                        }
                        else {
                            var RencanaSelesai_date_ = document.getElementById('RencanaSelesai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        }
                        rencanaselesaitahapan = rencanaselesaitahapan + ',' + RencanaSelesai_date_;

                        if (document.getElementById('RealisasiMulai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value == '') {
                            var RealisasiMulai_date_ = '0000-00-00';
                        }
                        else {
                            var RealisasiMulai_date_ = document.getElementById('RealisasiMulai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        }
                        mulaitahapan = mulaitahapan + ',' + RealisasiMulai_date_;


                        if (document.getElementById('RealisasiSelesai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value == '') {
                            var RealisasiSelesai_date_ = '0000-00-00';
                        }
                        else {
                            var RealisasiSelesai_date_ = document.getElementById('RealisasiSelesai_date_' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value;
                        }
                        selesaitahapan = selesaitahapan + ',' + RealisasiSelesai_date_;
                        filenya_tahapan = filenya_tahapan + ',' + document.getElementById('filenya_tahapan' + this.tahapanpekerjaan[z].id + this.tahapanpekerjaan[z].tahapan[i].id).value;
                    }
                }
            }

            //alert(this.selectedlelang);
            //alert(kodetahapan);
            //alert(idtahapan);
            //alert(pilihtahapan);
            //console.log(pilihtahapan);
            //console.log(rencanamulaitahapan);
            //console.log(rencanaselesaitahapan);
            //console.log(mulaitahapan);
            //console.log(selesaitahapan);
            //console.log(filenya_tahapan);
            //console.log(this.project_id);
            //console.log(JSON.parse(localStorage.getItem("isistem")));
            //console.log(this.secretencData);
            //alert(this.selectedid_user);
            //alert(idtahapan);
            //return false;

            var fd = new FormData();
            fd.append("metodelelang", this.selectedlelang);
            fd.append("kodetahapan", kodetahapan);
            fd.append("idtahapan", idtahapan);
            fd.append("pilihtahapan", pilihtahapan);
            fd.append("rencanamulaitahapan", rencanamulaitahapan);
            fd.append("rencanaselesaitahapan", rencanaselesaitahapan);
            fd.append("mulaitahapan", mulaitahapan);
            fd.append("selesaitahapan", selesaitahapan);
            fd.append("filenya_tahapan", filenya_tahapan);
            fd.append("project_id", this.project_id);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("id", this.secretencData);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_proc-Update", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/Procurement");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.initialize();
        this.ambildatareff();
        if (this.secretencData != 'Tambah') {
            this.AmbilDataSingel();
        }
    }
}
</script>
<style></style>